var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoldOtb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFB103"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61171_47271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4581 4H7.67134C7.11119 4.0006 6.57415 4.22338 6.17806 4.61947C5.78197 5.01556 5.55919 5.5526 5.55859 6.11275V17.9837C5.55879 18.5442 5.7814 19.0816 6.17753 19.478C6.57366 19.8744 7.11093 20.0974 7.67134 20.098H16.3233C16.8835 20.0974 17.4205 19.8746 17.8166 19.4785C18.2127 19.0824 18.4355 18.5454 18.4361 17.9852V8.446L14.4581 4ZM14.7363 5.821L16.8071 8.13475H14.7363V5.821ZM16.3233 19.09H7.67134C7.37801 19.0898 7.09675 18.9732 6.88933 18.7658C6.68191 18.5583 6.56529 18.2771 6.5651 17.9837V6.11275C6.56529 5.81942 6.68191 5.53815 6.88933 5.33073C7.09675 5.12331 7.37801 5.0067 7.67134 5.0065H13.7291V9.14125H17.4311V17.9837C17.431 18.1291 17.4023 18.2731 17.3465 18.4073C17.2908 18.5416 17.2092 18.6636 17.1063 18.7663C17.0035 18.869 16.8814 18.9505 16.747 19.006C16.6127 19.0616 16.4687 19.0901 16.3233 19.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69922 11.5469H10.9892V15.4169H9.69922V11.5469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6602 11.6953H13.9502V15.5653H12.6602V11.6953Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61171_47271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3966,
    height: 16.0965,
    fill: "white",
    transform: "translate(5.30078 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOtb);
export default __webpack_public_path__ + "static/media/holdOtb.7e07c1b13eb18dcfa22f2960e45d72c2.svg";
export { ForwardRef as ReactComponent };